<script>
  export let centered = false
  export let repliesButton = false
  export let handleClick
  export let textColor = '#696C85'
  export let hasHover = false
  export let fontWeight = 600
</script>

<style>
  :global(._2S1GQ) {
    font-size: 14px;
    padding: 12px 20px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    font-weight: 600;
    border: 0;
    text-align: left;
    padding-left: 0;
    margin-right: 14px;
    transition: 0.1s;
    background: none;
    box-shadow: none;
    outline: none;
    display: flex;
    align-items: center;
    width: auto;
  }

  .text-center {
    text-align: center;
    margin: auto;
    padding: 9px 14px;
  }

  .replies {
    position: relative;
  }

  :global(._2S1GQ:focus,)
  :global(._2S1GQ:active) {
    border: 0;
    outline: none;
    box-shadow: none;
  }

  .has-hover:hover {
    color: #0a0f3b;
  }
</style>

<button
  class="_2S1GQ"
  class:text-center={centered}
  class:replies={repliesButton}
  on:click={handleClick}
  style="color: {textColor}; font-weight: {fontWeight};"
  class:has-hover={hasHover}>
  <slot />
</button>
